export enum Mxa7xxModel {
	MXA710 = 'MXA710',
	MXA720 = 'MXA720'
}
